function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00016 1.33333C5.42016 1.33333 3.3335 3.42 3.3335 6C3.3335 7.16 3.66683 8.24666 4.2735 9.22666C4.90683 10.2533 5.74016 11.1333 6.38016 12.16C6.6935 12.66 6.92016 13.1267 7.16016 13.6667C7.3335 14.0333 7.4735 14.6667 8.00016 14.6667C8.52683 14.6667 8.66683 14.0333 8.8335 13.6667C9.08016 13.1267 9.30016 12.66 9.6135 12.16C10.2535 11.14 11.0868 10.26 11.7202 9.22666C12.3335 8.24666 12.6668 7.16 12.6668 6C12.6668 3.42 10.5802 1.33333 8.00016 1.33333ZM8.00016 7.83333C7.08016 7.83333 6.3335 7.08666 6.3335 6.16666C6.3335 5.24666 7.08016 4.49999 8.00016 4.49999C8.92016 4.49999 9.66683 5.24666 9.66683 6.16666C9.66683 7.08666 8.92016 7.83333 8.00016 7.83333Z",
  fill: "#BBC9CA"
});

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fd560c60.svg";
export { ForwardRef as ReactComponent };